const storageKey = (orderGroupId) => `deliverit.dropOffDraft.${orderGroupId}`;

const isComplete = (form) =>
  form.recipientName !== ""
  && form.recipientPhone !== ""
  && form.deliverDateTime !== ""
  && form.dropOffLocation.coordinate.latitude !== ""
  && form.dropOffLocation.coordinate.longitude !== "";

const isEmpty = (form) =>
  form.recipientName === ""
  && form.recipientPhone === ""
  && form.deliverDateTime === ""
  && form.dropOffLocation.address === "";

export const isDraftWorthKeeping = (form) => !isComplete(form) && !isEmpty(form);

export const clearDropOffDraft = (orderGroupId) => {
  if (!orderGroupId) return;

  try {
    localStorage.removeItem(storageKey(orderGroupId));
  } catch (e) { }
}

export const loadDropOffDraft = (orderGroupId) => {
  if (!orderGroupId) return null;

  try {
    const stored = localStorage.getItem(storageKey(orderGroupId));
    if (!stored) return null;

    const parsed = JSON.parse(stored);
    if (!parsed || typeof parsed !== "object" || !parsed.dropOffLocation) return null;

    return {
      ...parsed,
      deliverDateTime: parsed.deliverDateTime ? new Date(parsed.deliverDateTime) : ""
    };
  } catch (e) {
    clearDropOffDraft(orderGroupId);
    return null;
  }
}

export const saveDropOffDraft = (orderGroupId, form) => {
  if (!orderGroupId) return;

  if (!isDraftWorthKeeping(form)) {
    clearDropOffDraft(orderGroupId);
    return;
  }

  try {
    localStorage.setItem(storageKey(orderGroupId), JSON.stringify(form));
  } catch (e) { }
}
